module.exports = __webpack_public_path__ + "img/icon-quiz-menu-covid.a956ee6f.svg";